import ReactGA from 'react-ga4'
import { withRouter } from 'react-router-dom'

const RouteChangeTracker = ({ history }) => {
  history.listen((location, action) => {
    ReactGA.set({ page: location.pathname })
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search
    })

    if (location.pathname.includes('faq')) {
      window.$chatwoot?.toggle('open')
    }
  })
  return null
}

export default withRouter(RouteChangeTracker)
